import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcademicOverview = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 32,
	viewBox: "0 0 27 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.25 5.75H11.75C11.34 5.75 11 6.09 11 6.5V11.5C11 11.91 11.34 12.25 11.75 12.25H19.25C19.66 12.25 20 11.91 20 11.5V6.5C20 6.09 19.66 5.75 19.25 5.75ZM18.5 10.75H12.5V7.25H18.5V10.75Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25.75 0H5.75C2.58 0 0 2.58 0 5.75V25.75C0 28.92 2.58 31.5 5.75 31.5H25.75C26.16 31.5 26.5 31.16 26.5 30.75V0.75C26.5 0.34 26.16 0 25.75 0ZM5.75 30C3.48 30 1.63 28.2 1.52 25.95C1.66 25.81 1.75 25.62 1.75 25.41C1.75 23.7 3.23 21.87 6.48 21.87H22.36C22.77 21.87 23.11 21.53 23.11 21.12C23.11 20.71 22.77 20.37 22.36 20.37H6.48C4.21 20.37 2.54 21.16 1.5 22.28V5.75C1.5 3.41 3.41 1.5 5.75 1.5H25V24.67H12.98C12.57 24.67 12.23 25.01 12.23 25.42C12.23 25.83 12.57 26.17 12.98 26.17H25V30H5.75Z",
		fill: "currentColor"
	})]
});
export default SvgAcademicOverview;
